(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire9a00"];
var parcelRegister = parcelRequire.register;
parcelRegister("6RMtT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $66051c4e0612b22b$export$2e2bcd8739ae039);

var $2MgeJ = parcelRequire("2MgeJ");

var $bTBLz = parcelRequire("bTBLz");

var $9msyL = parcelRequire("9msyL");

var $28FCd = parcelRequire("28FCd");

var $7otmo = parcelRequire("7otmo");

var $6W3fz = parcelRequire("6W3fz");

var $17TIY = parcelRequire("17TIY");

var $jGY54 = parcelRequire("jGY54");

var $epZoF = parcelRequire("epZoF");

var $i2xP1 = parcelRequire("i2xP1");

var $2nKsZ = parcelRequire("2nKsZ");

var $7gxrj = parcelRequire("7gxrj");

var $ahcAq = parcelRequire("ahcAq");

var $fy0H4 = parcelRequire("fy0H4");

const $66051c4e0612b22b$var$_Player = ()=>{
    const { id: id } = (0, $bTBLz.useParams)();
    const fetchResult = (0, $ahcAq.default)({
        url: `${(0, $epZoF.Urls).ApiRestOtePlayersUrl}/${id}`,
        key: "ote_player"
    });
    const player = fetchResult.result?.read();
    if (!player) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $i2xP1.default), null);
    const team = player.ote_team;
    const descriptionTemplate = `${player.full_name} is a${player.height ? ` ${Math.floor(player.height / 12)}'${player.height % 12}"` : ""}${player.position ? ` ${(0, $jGY54.positions)[player.position].toLowerCase()}` : ""}${player.hometown ? ` from ${player.hometown}` : ""}.${player.ote_team ? player.is_current ? ` He currently plays for the ${player.ote_team.name}.` : ` He played for the ${player.ote_team.name}${player.professional_team ? ` and currently plays for the ${player.professional_team.name}` : ""}.` : player.professional_team ? ` He currently plays for the ${player.professional_team.name}.` : ""}`;
    const description = player.share_description || descriptionTemplate;
    (0, $7gxrj.useSetDocumentState)({
        title: player.full_name,
        image: [
            player.hero_image_path ? `https://images.overtime.tv/${player.hero_image_path}` : undefined,
            player.image_path ? `https://images.overtime.tv/${player.image_path}` : undefined
        ].filter(Boolean),
        description: description,
        color: (0, $fy0H4.colorFromInt)(player.ote_team?.primary_color)
    });
    const data = {
        "@context": "https://schema.org",
        "@type": "Person",
        mainEntityOfPage: {
            "@type": "WebPage",
            "@id": `https://overtimeelite.com/players/${player.id}`
        },
        affiliation: player.ote_team ? {
            "@type": "SportsTeam",
            name: player.ote_team?.name,
            url: `https://overtimeelite.com/teams/${player.ote_team?.slug}`
        } : undefined,
        description: description,
        birthDate: player.birthdate,
        image: player.image_path ? `https://images.overtime.tv/${player.image_path}` : undefined,
        name: player.full_name,
        givenName: player.first_name,
        familyName: player.family_name,
        height: player.height ? [
            {
                "@type": "QuantitativeValue",
                value: player.height,
                unitCode: "INH"
            }
        ] : undefined,
        weight: player.weight ? [
            {
                "@type": "QuantitativeValue",
                value: player.weight,
                unitCode: "LBR"
            }
        ] : undefined
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Player"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $17TIY.default), {
        team: team
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $7otmo.default), {
        player: player,
        team: team
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $6W3fz.default), {
        player: player,
        team: team
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(data)
        }
    }));
};
const $66051c4e0612b22b$var$Player = ()=>{
    const { id: id } = (0, $bTBLz.useParams)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $9msyL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $28FCd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $2nKsZ.default), {
        id: id,
        redirectPrefix: "/players"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement($66051c4e0612b22b$var$_Player, null))));
};
var $66051c4e0612b22b$export$2e2bcd8739ae039 = $66051c4e0612b22b$var$Player;

});
parcelRegister("7otmo", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab9486b94df45353$export$2e2bcd8739ae039);

var $275Aj = parcelRequire("275Aj");

var $2MgeJ = parcelRequire("2MgeJ");

var $5gQ0v = parcelRequire("5gQ0v");

var $7gWUw = parcelRequire("7gWUw");

var $jGY54 = parcelRequire("jGY54");

var $96bGs = parcelRequire("96bGs");

var $ki0Ss = parcelRequire("ki0Ss");

var $fy0H4 = parcelRequire("fy0H4");

const $ab9486b94df45353$var$Profile = ({ player: player, team: team })=>{
    const birthdate = new Date(player.birthdate);
    const now = new Date();
    const ageYears = now.getFullYear() - birthdate.getFullYear();
    const age = now.getMonth() > birthdate.getMonth() ? ageYears : now.getMonth() === birthdate.getMonth() && now.getDate() >= birthdate.getDate() ? ageYears : ageYears - 1;
    const teamColor = {
        color: team?.is_current ? (0, $fy0H4.colorFromInt)(team.secondary_foreground_color) : (0, (/*@__PURE__*/$parcel$interopDefault($96bGs))).COLOR.WHITE
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "PlayerProfile",
        style: {
            backgroundColor: team?.is_current ? (0, $fy0H4.colorFromInt)(team.secondary_color) : (0, (/*@__PURE__*/$parcel$interopDefault($96bGs))).COLOR.BRAND_PRIMARY
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $5gQ0v.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "ProfileContainer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        style: {
            backgroundImage: `linear-gradient(180deg, ${(0, $fy0H4.colorFromInt)(team?.primary_color ?? 0xaaaaaa)} 0%, ${(0, $fy0H4.colorFromInt)(team?.primary_color ?? 0xaaaaaa)} 20% , white)`
        },
        className: [
            "ImageContainer",
            !player.image_path ? "Placeholder" : null
        ].filter(Boolean).join(" ")
    }, player.image_path ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $ki0Ss.default), {
        src: `https://images.overtime.tv/${player.image_path}?quality=60`,
        alt: player.full_name
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("img", {
        alt: player.full_name,
        src: (0, $7gWUw.imgOteLogoWhiteSvg)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("h1", {
        style: teamColor
    }, player.full_name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Position"
    }, (0, $jGY54.positions)[player.position]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Rule",
        style: {
            backgroundColor: teamColor.color
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Vitals"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("label", {
        style: teamColor
    }, "Height"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", null, player.height > 0 ? `${Math.floor(player.height / 12)}' ${player.height % 12}"` : "N/A")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("label", {
        style: teamColor
    }, "Age"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", null, player.birthdate ? age : "N/A")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("label", {
        style: teamColor
    }, "Weight"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", null, player.weight ? `${player.weight} lbs` : "N/A")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("label", {
        style: teamColor
    }, "Grad Year"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", null, player.graduation_year ?? "N/A")), !(0, $275Aj.isEmpty)(player.hometown) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("label", {
        style: teamColor
    }, "Hometown"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Hometown"
    }, player.hometown)) : null)))));
};
var $ab9486b94df45353$export$2e2bcd8739ae039 = $ab9486b94df45353$var$Profile;

});

parcelRegister("6W3fz", function(module, exports) {

$parcel$export(module.exports, "default", () => $741fd04f4401d534$export$2e2bcd8739ae039);

var $275Aj = parcelRequire("275Aj");

var $2MgeJ = parcelRequire("2MgeJ");

var $bTBLz = parcelRequire("bTBLz");

var $28FCd = parcelRequire("28FCd");

var $gMp4q = parcelRequire("gMp4q");

var $humJf = parcelRequire("humJf");

var $b2Pgf = parcelRequire("b2Pgf");

var $jXzwG = parcelRequire("jXzwG");

const $741fd04f4401d534$var$Tabs = ({ player: player, team: team })=>{
    const { section: section } = (0, $bTBLz.useParams)();
    const seasons = (0, (/*@__PURE__*/$parcel$interopDefault($275Aj))).orderBy(player.ote_seasons_ote_players.filter((ps)=>ps.ote_season.should_show_for_players), [
        "ote_season.is_current",
        "ote_season.starts_at"
    ], [
        "desc",
        "asc"
    ]);
    const seasonTabs = seasons.map((ps)=>{
        return {
            name: ps.ote_season.name,
            text: ps.ote_season.name,
            component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $b2Pgf.default), {
                season: ps.ote_season,
                player: player
            })
        };
    });
    const playerTabs = [
        {
            name: "career",
            text: "Career",
            component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $jXzwG.default), {
                player: player,
                team: team
            })
        },
        ,
        !(0, (/*@__PURE__*/$parcel$interopDefault($275Aj))).isEmpty(player.biography) || !(0, (/*@__PURE__*/$parcel$interopDefault($275Aj))).isEmpty(player.hero_image_path) ? {
            name: "biography",
            text: "Biography",
            component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $humJf.default), {
                player: player
            })
        } : null
    ].filter(Boolean);
    const tabs = [
        ...seasonTabs,
        ...playerTabs
    ];
    const defaultTab = section ? section : tabs[0].name;
    const [tabIndex, setTabIndex] = (0, $2MgeJ.useState)(tabs.findIndex((t)=>t.name === defaultTab));
    const [tab, setTab] = (0, $2MgeJ.useState)(defaultTab);
    (0, $2MgeJ.useEffect)(()=>{
        let index = tabs.map((t)=>t.name).indexOf(tab);
        setTabIndex(index === -1 ? 0 : index);
    }, [
        tab
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "PlayerProfileTabs"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "TabBar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "TabContainer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $gMp4q.default), {
        links: tabs.map((t)=>[
                t.name,
                t.text
            ]),
        section: tab,
        useCallback: (t)=>setTab(t),
        root: `/players/${player.id}`,
        useHistoryState: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "TabContent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "TransitionContainer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "ContentGrid",
        style: {
            left: `${-100 * tabIndex}%`,
            gridTemplateColumns: "100%".repeat(tabs.length)
        }
    }, tabs.map((t)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            key: t.name,
            style: {
                maxHeight: tab === t.name ? null : 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $28FCd.default), {
            errorComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).Fragment, null)
        }, t.component));
    })))));
};
var $741fd04f4401d534$export$2e2bcd8739ae039 = $741fd04f4401d534$var$Tabs;

});
parcelRegister("humJf", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fb910f506aa7499$export$2e2bcd8739ae039);

var $275Aj = parcelRequire("275Aj");

var $2MgeJ = parcelRequire("2MgeJ");

var $5gQ0v = parcelRequire("5gQ0v");

var $feFQe = parcelRequire("feFQe");

var $ki0Ss = parcelRequire("ki0Ss");

const $1fb910f506aa7499$var$Biography = ({ player: player })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $5gQ0v.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "PlayerProfileBiography"
    }, player.hero_image_path ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "HeroContainer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $ki0Ss.default), {
        mobileWidth: 800,
        src: `https://images.overtime.tv/${player.hero_image_path}?quality=40`,
        alt: player.full_name
    })) : null, !(0, (/*@__PURE__*/$parcel$interopDefault($275Aj))).isEmpty(player.biography) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "BiographyContainer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("h2", null, "Biography"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $feFQe.default), {
        text: player.biography
    }))));
};
var $1fb910f506aa7499$export$2e2bcd8739ae039 = $1fb910f506aa7499$var$Biography;

});

parcelRegister("b2Pgf", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fc02ae2308c4ba2$export$2e2bcd8739ae039);

var $275Aj = parcelRequire("275Aj");

var $2MgeJ = parcelRequire("2MgeJ");

var $5wMv4 = parcelRequire("5wMv4");

var $epZoF = parcelRequire("epZoF");

var $enLvs = parcelRequire("enLvs");

var $ahcAq = parcelRequire("ahcAq");

const $9fc02ae2308c4ba2$var$Season = ({ season: season, player: player })=>{
    const fetchResult = (0, $ahcAq.default)({
        url: `${(0, $epZoF.Urls).ApiRestOteSeasonsUrl}/${season.id}/ote_games?ote_player_id=${player.id}`,
        key: "ote_games"
    });
    const seasonPlayer = player.ote_seasons_ote_players.find((s)=>s.ote_season_id === season.id);
    const games = (0, $275Aj.sortBy)(fetchResult.result.read().filter((g)=>g.ote_games_ote_players_ote_teams[0]?.minutes > 0), "starts_at");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "PlayerSeason"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $5wMv4.default), {
        title: "Game",
        rows: games.map((g)=>({
                ...g.ote_games_ote_players_ote_teams[0],
                ote_game: g
            })),
        averageRow: seasonPlayer,
        per40Row: seasonPlayer,
        rowHeader: (r)=>season.should_show_for_teams ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("a", {
                href: `/games/${r.ote_game_id}`,
                className: "Game"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
                title: r.ote_game.competition_name
            }, r.ote_game.ote_games_ote_teams.find((t)=>!t.is_home_team).ote_team.name, " @\n", r.ote_game.ote_games_ote_teams.find((t)=>t.is_home_team).ote_team.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
                className: "Date"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $enLvs.default), {
                timestamp: r.ote_game.starts_at
            }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
                className: "Game"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
                title: r.ote_game.competition_name
            }, r.ote_game.ote_games_ote_teams.find((t)=>!t.is_home_team).ote_team.name, " @\n", r.ote_game.ote_games_ote_teams.find((t)=>t.is_home_team).ote_team.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
                className: "Date"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $enLvs.default), {
                timestamp: r.ote_game.starts_at
            })))
    }));
};
var $9fc02ae2308c4ba2$export$2e2bcd8739ae039 = $9fc02ae2308c4ba2$var$Season;

});

parcelRegister("jXzwG", function(module, exports) {

$parcel$export(module.exports, "default", () => $b65b8b532303b7e9$export$2e2bcd8739ae039);

var $275Aj = parcelRequire("275Aj");

var $2MgeJ = parcelRequire("2MgeJ");

var $fElq7 = parcelRequire("fElq7");

var $5gQ0v = parcelRequire("5gQ0v");

var $96bGs = parcelRequire("96bGs");

var $fy0H4 = parcelRequire("fy0H4");

const $b65b8b532303b7e9$var$Season = ({ season: season, team: team })=>{
    const Statistic = ({ value: value, label: label, isFloat: isFloat = true })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: "Statistic"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("label", {
            style: {
                color: (0, $fy0H4.colorFromInt)(team?.secondary_foreground_color)
            }
        }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
            className: "Value"
        }, isFloat ? (value ?? 0).toFixed(1) : value ?? 0));
    const perSuffix = season.ote_season.is_per_40 ? "40" : "game";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Season",
        style: {
            backgroundColor: team?.is_current ? (0, $fy0H4.colorFromInt)(team.secondary_color) : (0, (/*@__PURE__*/$parcel$interopDefault($96bGs))).COLOR.BLACK
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Name"
    }, season.ote_season.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Statistics"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement(Statistic, {
        label: `Points Per ${perSuffix}`,
        value: season[`points_per_${perSuffix}`]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Rule"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement(Statistic, {
        label: `Rebounds Per ${perSuffix}`,
        value: season[`rebounds_per_${perSuffix}`]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "VRule"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement(Statistic, {
        label: `Assists Per ${perSuffix}`,
        value: season[`assists_per_${perSuffix}`]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "Rule"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement(Statistic, {
        label: `Steals Per ${perSuffix}`,
        value: season[`steals_per_${perSuffix}`]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "VRule"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement(Statistic, {
        label: `Blocks Per ${perSuffix}`,
        value: season[`blocks_per_${perSuffix}`]
    })), !season.ote_season.is_per_40 && season.ote_season.should_show_for_players ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "MoreContainer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $fElq7.default), {
        style: {
            background: team?.is_current ? (0, $fy0H4.colorFromInt)(team.primary_color) : (0, (/*@__PURE__*/$parcel$interopDefault($96bGs))).COLOR.WHITE,
            color: team?.is_current ? (0, $fy0H4.colorFromInt)(team.foreground_color) : (0, (/*@__PURE__*/$parcel$interopDefault($96bGs))).COLOR.BLACK
        },
        href: `/players/${season.ote_player_id}/seasons/${season.ote_season_id}`
    }, "Per Game Stats")) : null);
};
const $b65b8b532303b7e9$var$Seasons = ({ player: player, team: team })=>{
    const seasons = player.ote_seasons_ote_players?.filter((s)=>s.ote_season.should_show_for_players && s.minutes > 0);
    if (seasons.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "PlayerSeasons"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement((0, $5gQ0v.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement("div", {
        className: "SeasonsContainer"
    }, (0, $275Aj.sortBy)(seasons, "updated_at").reverse().map((s)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2MgeJ))).createElement($b65b8b532303b7e9$var$Season, {
            key: s.id,
            season: s,
            team: team
        })))));
};
var $b65b8b532303b7e9$export$2e2bcd8739ae039 = $b65b8b532303b7e9$var$Seasons;

});


parcelRegister("2nKsZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1312dd9ac5d61a2a$export$2e2bcd8739ae039);

var $5RGWv = parcelRequire("5RGWv");

var $275Aj = parcelRequire("275Aj");
parcelRequire("2MgeJ");

var $gEIs8 = parcelRequire("gEIs8");

var $i2xP1 = parcelRequire("i2xP1");
var $1312dd9ac5d61a2a$export$2e2bcd8739ae039 = ({ id: id, redirectPrefix: redirectPrefix, children: children })=>{
    if (redirectPrefix.endsWith("/")) console.warn("Don't include trailing slash in redirectPrefix");
    if (!(0, $gEIs8.default)(id)) {
        const fixedId = id.slice(0, id.match(/[^a-f0-9\-]/)?.index);
        if (typeof window !== "undefined" && fixedId !== id && !(0, $275Aj.isEmpty)(fixedId)) {
            location.href = `${redirectPrefix}/${fixedId}`;
            return;
        } else return /*#__PURE__*/ (0, $5RGWv.jsx)((0, $i2xP1.default), {});
    }
    return children;
};

});
parcelRegister("gEIs8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c202dd2ea31b7d5e$export$2e2bcd8739ae039);

var $l2KrZ = parcelRequire("l2KrZ");
function $c202dd2ea31b7d5e$var$validate(uuid) {
    return typeof uuid === "string" && (0, $l2KrZ.default).test(uuid);
}
var $c202dd2ea31b7d5e$export$2e2bcd8739ae039 = $c202dd2ea31b7d5e$var$validate;

});
parcelRegister("l2KrZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f51dd0f5ccbfc5f0$export$2e2bcd8739ae039);
var $f51dd0f5ccbfc5f0$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});




})();
//# sourceMappingURL=Player.ff9ec469.js.map
